













































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";
import MonitoringTransfusiTtvTimeline from "./MonitoringTransfusiTtvTimeline.vue";
import MonitoringTransfusiReaksiPanel from "./MonitoringTransfusiReaksiPanel.vue";
import MonitoringTransfusiFinalisasi from "./MonitoringTransfusiFinalisasi.vue";
import MonitoringTransfusiLaporanReaksi from "./MonitoringTransfusiLaporanReaksi.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { appModule } from "@/store/modules/app";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";

@Component({
  components: {
    MonitoringTransfusiTtvTimeline,
    MonitoringTransfusiReaksiPanel,
    MonitoringTransfusiFinalisasi,
    MonitoringTransfusiLaporanReaksi,
    PersonAutoComplete,
    VCDateTimePicker,
  }
})
export default class MonitoringTransfusiDetail extends Mixins(PrefillMixin) {
  @Prop() monitoringData!: any;
  @Prop() register!: string | number;
  @Prop() rm!: string;
  @Prop({ default: false }) readonly!: boolean;

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "monitoring_transfusi";

  prefillResolvePath(path: string) {
    if (path === "golongan_darah_pasien") {
      return {
        get: () => this.form.golongan_darah_pasien,
        set: (v) => {
          this.form.golongan_darah_pasien = v;
        }
      };
    }
    return { get: () => "__skip__", set: () => undefined };
  }
  // ───────────────────────────────────────────────────────────────────

  monitoring: any = null;
  currentStep = 1;
  saving = false;
  savingMulai = false;

  form: any = {
    register_id: "",
    pasien_rm: "",
    unit_id: null,
    tanggal_transfusi: toDateString(new Date()),
    mulai_at: null,
    selesai_at: null,
    golongan_darah_pasien: null,
    rhesus_pasien: null,
    nomor_kantong: "",
    jenis_komponen: null,
    golongan_darah_donor: null,
    rhesus_donor: null,
    volume_kantong_ml: null,
    hasil_crossmatch: null,
    tanggal_kadaluarsa: "",
    indikasi: "",
    hb_pre_transfusi: null,
    tetesan_per_menit: null,
    perawat_pelaksana_user_id: null,
    dpjp_user_id: null,
    verifikasi_identitas: {
      pasien_gelang: false,
      kantong_label: false,
      goldar_cocok: false,
      crossmatch_cocok: false,
      crossmatch_incompatible: false,
      exp_valid: false,
      verifikator_1: "",
      verifikator_2: "",
    },
  };

  goldarOptions = [
    { text: "A", value: "A" },
    { text: "B", value: "B" },
    { text: "AB", value: "AB" },
    { text: "O", value: "O" },
  ];

  rhesusOptions = [
    { text: "Positif (+)", value: "positif" },
    { text: "Negatif (-)", value: "negatif" },
  ];

  komponenOptions = [
    { text: "PRC (Packed Red Cell)", value: "PRC" },
    { text: "WB (Whole Blood)", value: "WB" },
    { text: "TC (Thrombocyte Concentrate)", value: "TC" },
    { text: "FFP (Fresh Frozen Plasma)", value: "FFP" },
    { text: "Cryoprecipitate", value: "Cryoprecipitate" },
    { text: "Trombosit Aferesis", value: "Trombosit Aferesis" },
    { text: "Lainnya", value: "Lainnya" },
  ];

  crossmatchOptions = [
    { text: "Mayor Compatible", value: "mayor_compatible" },
    { text: "Minor Compatible", value: "minor_compatible" },
    { text: "Incompatible", value: "incompatible" },
  ];

  async mounted() {
    if (this.monitoringData) {
      this.monitoring = this.monitoringData;
      this.populateForm();
      this.setInitialStep();
    } else {
      this.form.register_id = this.register;
      this.form.pasien_rm = this.rm;
      this.form.unit_id = userModule.user?.unit_id || null;
      if (!this.readonly) {
        // Soft-prefill golongan darah pasien dari master SIMRS /
        // monitoring transfusi sebelumnya (field kosong saja).
        this.$nextTick(() => {
          this.loadPrefill({
            pasien_rm: String(this.rm),
            register_id: this.register
          });
        });
      }
    }
  }

  get isLocked(): boolean {
    return this.monitoring?.is_locked || false;
  }

  get tanggalTransfusiDate(): Date | null {
    return composeDate(this.form.tanggal_transfusi);
  }
  set tanggalTransfusiDate(val: Date | null) {
    this.form.tanggal_transfusi = toDateString(val);
  }

  get kadaluarsaDate(): Date | null {
    return composeDate(this.form.tanggal_kadaluarsa);
  }
  set kadaluarsaDate(val: Date | null) {
    this.form.tanggal_kadaluarsa = toDateString(val);
  }

  get mulaiAtDate(): Date | null {
    return composeDate(this.form.mulai_at, (this.form.mulai_at || "").slice(11, 16));
  }
  set mulaiAtDate(val: Date | null) {
    this.form.mulai_at = val ? `${toDateString(val)} ${toTimeString(val)}:00` : null;
  }

  idKaryawanByNama(nama: string): number[] {
    if (!nama) return [];
    const found = (storePerawat.listKaryawan as any[]).filter(it => it.nama === nama);
    return found.map(it => it.id);
  }

  get excludeVerifikator1(): number[] {
    return this.idKaryawanByNama(this.form.verifikasi_identitas.verifikator_2);
  }

  get excludeVerifikator2(): number[] {
    return this.idKaryawanByNama(this.form.verifikasi_identitas.verifikator_1);
  }

  onCrossmatchCocok(val: boolean) {
    if (val) {
      this.form.verifikasi_identitas.crossmatch_incompatible = false;
    }
  }

  onCrossmatchIncompatible(val: boolean) {
    if (val) {
      this.form.verifikasi_identitas.crossmatch_cocok = false;
    }
  }

  get verifikasiKurang(): string[] {
    const v = this.form.verifikasi_identitas;
    const kurang: string[] = [];

    if (!v.pasien_gelang) kurang.push("Gelang identitas pasien belum dicentang");
    if (!v.kantong_label) kurang.push("Label kantong darah belum dicentang");
    if (!v.goldar_cocok) kurang.push("Kecocokan golongan darah belum dicentang");
    if (!v.crossmatch_cocok && !v.crossmatch_incompatible) {
      kurang.push("Hasil crossmatch belum dicentang (compatible atau incompatible)");
    }
    if (!v.exp_valid) kurang.push("Tanggal kadaluarsa belum dicentang");
    if (!v.verifikator_1) kurang.push("Verifikator 1 belum dipilih");
    if (!v.verifikator_2) kurang.push("Verifikator 2 belum dipilih");
    if (v.verifikator_1 && v.verifikator_2 && v.verifikator_1 === v.verifikator_2) {
      kurang.push("Verifikator 1 dan Verifikator 2 tidak boleh orang yang sama");
    }

    return kurang;
  }

  get allVerified(): boolean {
    return this.verifikasiKurang.length === 0;
  }

  get step1Complete(): boolean { return !!this.monitoring?.id; }
  get step2Complete(): boolean { return !!this.monitoring?.mulai_at && (this.monitoring?.ttvs?.length || 0) > 0; }
  get step3Complete(): boolean { return !!this.monitoring?.kesimpulan; }

  get canEditStep2(): boolean { return !!this.monitoring?.mulai_at; }
  get canEditStep3(): boolean { return !!this.monitoring?.can_finalize; }

  setInitialStep() {
    if (!this.monitoring) return;
    if (this.monitoring.kesimpulan || this.monitoring.is_locked) {
      this.currentStep = 3;
    } else if (this.monitoring.mulai_at) {
      this.currentStep = 2;
    } else {
      this.currentStep = 1;
    }
  }

  populateForm() {
    if (!this.monitoring) return;
    const m = this.monitoring;
    this.form = {
      register_id: m.register_id,
      pasien_rm: m.pasien_rm,
      unit_id: m.unit_id,
      tanggal_transfusi: m.tanggal_transfusi,
      mulai_at: this.srvToLocal(m.mulai_at),
      selesai_at: this.srvToLocal(m.selesai_at),
      golongan_darah_pasien: m.golongan_darah_pasien,
      rhesus_pasien: m.rhesus_pasien,
      nomor_kantong: m.nomor_kantong,
      jenis_komponen: m.jenis_komponen,
      golongan_darah_donor: m.golongan_darah_donor,
      rhesus_donor: m.rhesus_donor,
      volume_kantong_ml: m.volume_kantong_ml,
      hasil_crossmatch: m.hasil_crossmatch,
      tanggal_kadaluarsa: m.tanggal_kadaluarsa,
      indikasi: m.indikasi,
      hb_pre_transfusi: m.hb_pre_transfusi,
      tetesan_per_menit: m.tetesan_per_menit,
      perawat_pelaksana_user_id: m.perawat_pelaksana_user_id,
      dpjp_user_id: m.dpjp_user_id,
      verifikasi_identitas: {
        pasien_gelang: false,
        kantong_label: false,
        goldar_cocok: false,
        crossmatch_cocok: false,
        crossmatch_incompatible: false,
        exp_valid: false,
        verifikator_1: "",
        verifikator_2: "",
        ...(m.verifikasi_identitas || {}),
      },
    };
  }

  srvToLocal(val: any): string | null {
    if (!val) return null;
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return null;
    return `${toDateString(d)} ${toTimeString(d)}:00`;
  }

  async simpanProduk() {
    if (this.saving) return;
    this.saving = true;
    try {
      const resp = await MonitoringTransfusiSvc.create(this.form);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Monitoring transfusi dibuat");
        this.monitoring = resp.data.data;
        this.populateForm();
        this.$forceUpdate();
        this.$emit("saved");
      }
    } catch {
      // handled by service ErrorAlert
    }
    this.saving = false;
  }

  async updateProduk() {
    this.saving = true;
    try {
      const resp = await MonitoringTransfusiSvc.update(this.monitoring.id, this.form);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Data diperbarui");
        this.monitoring = resp.data.data;
        this.populateForm();
        this.$emit("saved");
      }
    } catch {
      // handled
    }
    this.saving = false;
  }

  async mulaiTransfusi() {
    if (this.savingMulai) return;
    this.savingMulai = true;
    try {
      const resp = await MonitoringTransfusiSvc.mulaiTransfusi(this.monitoring.id, {
        mulai_at: this.form.mulai_at,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Transfusi dimulai");
        this.monitoring = resp.data.data;
        this.populateForm();
        this.currentStep = 2;
        this.$emit("saved");
      }
    } catch {
      // handled
    }
    this.savingMulai = false;
  }

  async refreshData() {
    if (!this.monitoring?.id) return;
    try {
      const resp = await MonitoringTransfusiSvc.find(this.monitoring.id);
      if (resp?.data?.status == "1") {
        this.monitoring = resp.data.data;
        this.populateForm();
      }
    } catch {
      // handled
    }
    this.$emit("saved");
  }

  cetakPdf() {
    if (this.monitoring?.id) {
      MonitoringTransfusiSvc.printPdf(this.monitoring.id);
    }
  }
}
